import ArticleList from 'components/articles/ArticleList';
import React from 'react';
import Page from './Page';
import { useSearchParams } from 'react-router-dom';

export default function SatsangPage() {
	const [params] = useSearchParams();
	const videos = params.get('media') === 'video';
	return (
		<Page title={videos ? 'Video Satsang' : 'Satsang'} includeBottomNavigation fullscreen dark>
			<ArticleList recordType='satsang' contextVideo={videos} />
		</Page>
	);
}
